module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_shinjuku-6d4200cc794ba1f41374b608dddcf809.jpg";